// Plain, case-insensitive substring search over the rendered TEXT of a DOM subtree — used by the
// Settings page's page-search field (components/SettingsSearch.tsx). Unlike lib/find-replace.ts
// (a markdown string) or components/editor/find-in-editor.ts (a ProseMirror doc), this walks
// actual DOM text nodes: the settings page has no document model behind it, just rendered static
// content, so a Range into the live DOM is the only coordinate space available.
//
// Matching is per TEXT NODE, never across element boundaries — the same documented simplification
// find-replace.ts and find-in-editor.ts each make for their own coordinate space.

/** Every non-overlapping occurrence of `query` under `root`, in document order, as a live Range. */
export function findTextRanges(root: Node, query: string): Range[] {
  if (query.trim() === '') return []
  const needle = query.toLowerCase()
  const ranges: Range[] = []
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
  let node = walker.nextNode()
  while (node) {
    const hay = (node.textContent ?? '').toLowerCase()
    let from = 0
    while (from <= hay.length - needle.length) {
      const idx = hay.indexOf(needle, from)
      if (idx === -1) break
      const range = document.createRange()
      range.setStart(node, idx)
      range.setEnd(node, idx + needle.length)
      ranges.push(range)
      from = idx + needle.length
    }
    node = walker.nextNode()
  }
  return ranges
}
